<template>
  <div class="main-wrap">
    <div class="header">
      <div class="title">
        <div class="left-title">{{scoolName}}</div>
        <div class="right-time">
          <div>{{dateTimeObj.currentDate}}</div>
          <div>{{dateTimeObj.currentTime}}</div>
        </div>
      </div>
      <div class="status">{{noticeText}}</div>
    </div>
    <div class="body-wrap">
      <div class="body">
        <div class="weifx">
          <div class="title" style="border-bottom: 1px solid #ff0000">未放学</div>
          <vueSeamlessScroll :data="weifxArr" :class-option="defaultOption" class="seamless-warp">
            <div class="content">
              <span class="item" :style="{width: item.classType===1 ? '100%' : '50%' }" v-for="item of weifxArr" :key="item.id">{{item.className}}</span>
            </div>
          </vueSeamlessScroll>
        </div>
        <div class="fxzhong">
          <div class="title" style="border-bottom: 1px solid #c6f">放学中</div>
          <vueSeamlessScroll
            :data="fxzhongArr"
            :class-option="defaultOption2"
            class="seamless-warp"
          >
            <div class="content">
              <span
                class="item"
                style="width:100%"
                v-for="item of fxzhongArr"
                :key="item.id"
              >{{item.className}}</span>
            </div>
          </vueSeamlessScroll>
        </div>
        <div class="yifx">
          <div class="title" style="border-bottom: 1px solid #3f3">已放学</div>
          <vueSeamlessScroll :data="yifxArr" :class-option="defaultOption" class="seamless-warp">
            <div class="content">
              <span class="item" :style="{width: item.classType===1 ? '100%' : '50%' }" v-for="item of yifxArr" :key="item.id">{{item.className}}</span>
            </div>
          </vueSeamlessScroll>
        </div>
      </div>
    </div>
    <div class="footer">
      <div :class="['footer-item', item.class]" v-for="item of footerArr" :key="item.text">
        <span class="block"></span>
        <span style="margin-left:20px">{{item.text}}</span>
      </div>
    </div>
  </div>
</template>

<script>

import myMixin from "./mixin/index.js";

export default {
  mixins: [myMixin],
};
</script>

<style lang='scss' scoped>
.main-wrap {
  width: 100vw;
  height: 100vh;
  padding: 0px;
  .header {
    width: 100%;
    height: 20vh;
    background: #1d9ed7;
    border-radius: 30px 30px 0 0;
    .title {
      height: 65%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;
      .left-title {
        width: 80%;
        height: 100%;
        font-size: 65px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-shadow: 6px 6px 8px #070707;
      }
      .right-time {
        width: 20%;
        min-width:300px;
        height: 100%;
        font-size: 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
      }
    }
    .status {
      height: 35%;
      color: #ffff00;
      font-size: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .body-wrap {
    width: 100%;
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .body {
      width: 99%;
      height: 98%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      background: black;
      border-radius: 30px;
      // background: url('~@/assets/images/bg2.jpg') no-repeat center;
      // background-size: 100% 100%;
      .title {
        font-size: 40px;
        height: 13%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .seamless-warp {
        height: 87%;
        overflow: hidden;

        .content {
          font-size: 30px;
          height: 90%;
          display: flex;
          justify-content: flex-start;
          flex-flow: row wrap;

          .item {
            width: 50%;
            height: 60px;
            line-height: 60px;
            text-align: center;
            white-space:nowrap; 
            text-overflow:ellipsis; 
            overflow:hidden;
          }
        }
      }

      .weifx {
        width: 35%;
        height: 95%;
        border: 1px solid #ff0000;
        border-radius: 20px;
        box-shadow: 0px 0px 20px #fff;
        color: #ff0000;
      }
      .fxzhong {
        width: 20%;
        height: 95%;
        border: 1px solid #c6f;
        border-radius: 20px;
        box-shadow: 0px 0px 20px #fff;
        color: #c6f;
      }
      .yifx {
        width: 35%;
        height: 95%;
        border: 1px solid #3f3;
        border-radius: 20px;
        box-shadow: 0px 0px 20px #fff;
        color: #3f3;
      }
    }
  }
  .footer {
    width: 100%;
    height: 10vh;
    background: black;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 30px;
    border-radius: 0 0 30px 30px;

    .footer-item {
      width: 30%;
      display: flex;
      justify-content: center;
      align-items: center;

      .block {
        display: inline-block;
        width: 60px;
        height: 60px;
        border-radius: 10px;
      }
    }
    .redC {
      color: #ff0000;
      .block {
        background: #ff0000;
      }
    }
    .purpleC {
      color: #c6f;
      .block {
        background: #c6f;
      }
    }
    .greenC {
      color: #3f3;
      .block {
        background: #3f3;
      }
    }
  }
}
</style>
